window._ = require('lodash');

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    // Bootstrap
    require('bootstrap-sass/assets/javascripts/bootstrap');

    // Select2 (for using custom select dropdowns)
    require('select2/src/js/jquery.select2');
    // Without this some unexplained behavior starts to happen on the client-side, like "Uncaught TypeError - searchLabel() is not a function"
    // Apparently select2 language settings won't work quite right either... https://stackoverflow.com/a/57000033/1140110
    // We'll need to do this for every select2 language file we want to support
    const EnglishTranslation = require("select2/src/js/select2/i18n/en");
    const GermanTranslation = require("select2/src/js/select2/i18n/de");
    const Translation = require('select2/src/js/select2/translation');
    Translation._cache["./i18n/en"] = EnglishTranslation;
    Translation._cache["./i18n/de"] = GermanTranslation;
    Translation._cache["en"] = EnglishTranslation;
    Translation._cache["de"] = GermanTranslation;
} catch (e) {}

window.swal = require('sweetalert2/dist/sweetalert2');

window.toastr = require('toastr/toastr');

window.dtPageCalc = require('./datatable_page_calculate');

require('owl.carousel/src/js/owl.carousel');